import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
function fieldClasses(hasError, shake) {
    return [
        'w-full px-3 bg-surface-container-low rounded-[6px]',
        'text-[15px] font-normal text-on-surface',
        'placeholder:text-on-surface-variant',
        'border transition-colors duration-150',
        'focus:outline-none',
        hasError
            ? 'border-error border-2 focus:border-error'
            : 'border-outline-variant border focus:border-primary focus:border-2',
        shake ? 'animate-shake' : '',
    ].join(' ');
}
export function Input({ label, error, hint, id: propId, className = '', ...props }) {
    const autoId = useId();
    const id = propId ?? autoId;
    return (_jsxs("div", { className: `flex flex-col gap-1 ${className}`, children: [label && (_jsx("label", { htmlFor: id, className: "text-[12px] font-medium text-on-surface-variant uppercase tracking-[0.06em]", children: label })), _jsx("input", { id: id, ...props, className: fieldClasses(!!error, !!error) + ' h-11' }), error && (_jsx("p", { className: "text-[12px] font-medium text-error", children: error })), !error && hint && (_jsx("p", { className: "text-[12px] font-normal text-on-surface-variant", children: hint }))] }));
}
export function Textarea({ label, error, hint, id: propId, className = '', ...props }) {
    const autoId = useId();
    const id = propId ?? autoId;
    return (_jsxs("div", { className: `flex flex-col gap-1 ${className}`, children: [label && (_jsx("label", { htmlFor: id, className: "text-[12px] font-medium text-on-surface-variant uppercase tracking-[0.06em]", children: label })), _jsx("textarea", { id: id, ...props, className: fieldClasses(!!error, !!error) + ' min-h-[72px] py-3 resize-y' }), error && (_jsx("p", { className: "text-[12px] font-medium text-error", children: error })), !error && hint && (_jsx("p", { className: "text-[12px] font-normal text-on-surface-variant", children: hint }))] }));
}
